import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BusinessTypeDto } from '../../../../generated-model/models';
import { PageResponse } from '../../../shared/commons/page-response';

@Injectable({ providedIn: 'root' })
export class BusinessTypeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/business-types';

  getAllBusinessTypes(page: number, size: number, search: string = "", state: number | null = null): Observable<PageResponse<BusinessTypeDto>> {
    return this.http.get<PageResponse<BusinessTypeDto>>(this.apiUrl + '?page=' + page + '&size=' + size + '&search=' + encodeURIComponent(search) + (state == null ? '' : '&state=' + state));
  }

  getActiveBusinessTypes(): Observable<BusinessTypeDto[]> {
    return this.http.get<BusinessTypeDto[]>(`${this.apiUrl}/active`);
  }

  getBusinessTypeById(id: number): Observable<BusinessTypeDto> {
    return this.http.get<BusinessTypeDto>(`${this.apiUrl}/${id}`);
  }

  createBusinessType(businessType: BusinessTypeDto): Observable<BusinessTypeDto> {
    return this.http.post<BusinessTypeDto>(this.apiUrl, businessType);
  }

  updateBusinessType(id: number, businessType: BusinessTypeDto): Observable<BusinessTypeDto> {
    return this.http.put<BusinessTypeDto>(`${this.apiUrl}/${id}`, businessType);
  }

  deleteBusinessType(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
